import { GET_ALL_ASSESSMENT_DETAILS, GET_ALL_ASSESSMENT_DETAILS_FAIL, GET_ALL_ASSESSMENT_DETAILS_SUCCESS, GET_ASSESSMENT_RECORD, GET_ASSESSMENT_RECORD_FAIL, GET_ASSESSMENT_RECORD_SUCCESS } from "./actionTypes";

export const getAllAssessmentDetails = (requestData) => ({
    type: GET_ALL_ASSESSMENT_DETAILS,
    payload: requestData
  });
  
  export const getAllAssessmentDetailsSuccess = (data) => ({
    type: GET_ALL_ASSESSMENT_DETAILS_SUCCESS,
    payload: data,
  });
  
  export const getAllAssessmentDetailsFail = (error) => ({
    type: GET_ALL_ASSESSMENT_DETAILS_FAIL,
    payload: error,
  });

  export const getAssessmentRecord = (id) => ({
    type: GET_ASSESSMENT_RECORD,
    payload: id
  });
  
  export const getAssessmentRecordSuccess = (data) => ({
    type: GET_ASSESSMENT_RECORD_SUCCESS,
    payload: data,
  });
  
  export const getAssessmentRecordFail = (error) => ({
    type: GET_ASSESSMENT_RECORD_FAIL,
    payload: error,
  });